import React, { useRef } from "react";
import Slider from "react-slick";
import "../assets/css/review.css";
function Review() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
     responsive: [
    {
      breakpoint: 1024, // Tablet / small laptop
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768, // Large Mobile
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480, // Small Mobile
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
  };


  return (
    <div className="slider">
      <Slider {...settings}>
  <div className="slider-item">
  <h3>Avon Tattoo Supply</h3>
  <h4>E-commerce Tattoo Website</h4>
  <p>
    "Dillip built a high-performance e-commerce platform with product filters, cart, and payment integration. His backend knowledge really streamlined our business operations."
  </p>
  <a href="https://avontattoosupply.in" target="_blank" className="visit-btn">Visit Site</a>
</div>

<div className="slider-item">
  <h3>Sayesha Accounting</h3>
  <h4>Professional Services Website</h4>
  <p>
    "He delivered a fast, professional website that reflects our services perfectly. Communication was smooth, and delivery was right on time!"
  </p>
  <a href="https://sayeshaaccounting.in" target="_blank" className="visit-btn">Visit Site</a>
</div>

<div className="slider-item">
  <h3>SmartQRTech</h3>
  <h4>QR Generator & Tech Platform</h4>
  <p>
    "Dillip developed a dynamic QR generator site with user dashboard and backend logic. He handled complex features easily. Truly skilled and reliable!"
  </p>
  <a href="https://smartqrtech.in" target="_blank" className="visit-btn">Visit Site</a>
</div>

<div className="slider-item">
  <h3>OfficeWallah</h3>
  <h4>Business Dashboard Website</h4>
  <p>
    "We got a clean and intuitive admin dashboard with smart analytics and secure user roles. Highly recommend him for web applications."
  </p>
  <a href="https://officewallah.in" target="_blank" className="visit-btn">Visit Site</a>
</div>

<div className="slider-item">
  <h3>SkillsTech Academy</h3>
  <h4>EdTech Platform with Certificates</h4>
  <p>
    "Our complete training portal, resume builder, and certificate system were made from scratch. Dillip understood our goals and delivered them perfectly!"
  </p>
  <a href="https://skillstechacademy.in" target="_blank" className="visit-btn">Visit Site</a>
</div>

<div className="slider-item">
  <h3>Atmanirbhar Academy</h3>
  <h4>Course Management Website</h4>
  <p>
    "The academy website was perfectly developed with course listings, certificate system, and lead collection. Dillip delivered everything with great attention to detail."
  </p>
  <a href="https://atmanirbharacademy.in" target="_blank" className="visit-btn">Visit Site</a>
</div>

<div className="slider-item">
  <h3>MS Fruit</h3>
  <h4>Fresh Fruit Supplier Website</h4>
  <p>
    "From product showcase to enquiry forms and responsive design, the MS Fruit website looks professional and works smoothly on all devices. Excellent job!"
  </p>
  <a href="https://msfruit.in" target="_blank" className="visit-btn">Visit Site</a>
</div>

<div className="slider-item">
  <h3>Bigxtech</h3>
  <h4>Cybersecurity Services Website</h4>
  <p>
    "He built a secure multi-service site covering MSSP, CTI-IR, CTEM and more. His understanding of technical structure and UI delivery was impressive."
  </p>
  <a href="https://bigxtech.com" target="_blank" className="visit-btn">Visit Site</a>
</div>

      </Slider>
    </div>
  );
}

export default Review;
